export default __webpack_public_path__ + "static/media/07-fosbury.b8570177.mp4";